import styled from 'styled-components';
import { Flexbox, Typography } from '@hiiretail/synergy-ui';

export const PermissionBox = styled(Flexbox)`
  background-color: #7f7f7f33;
  padding: 0 ${({ theme }) => theme.spacing(2)}px;
  border-radius: 8px;
`;

export const TypographyWithEllipsis = styled(Typography)`
  text-overflow: ellipsis;
  white-space: nowrap;
  width: calc(100% - 1px);
`;
